import { useLocation } from 'react-router-dom'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import qualificationEntries from 'modules/onboarding/store/collections/qualificationEntries'
import QualificationEntry from 'modules/onboarding/store/models/QualificationEntry'

type Props = {
  flashError: boolean
  flashSuccess?: boolean
}

const shouldContactSales = (inFreeTrial: boolean, signupNumberEmployees: number) => {
  if (!inFreeTrial) return false

  // FIXME: Notice for Factorial we don't have number_employees, therefore this
  // will always return true in dev environments
  if (signupNumberEmployees && signupNumberEmployees <= 20) return false

  return true
}

const useNewContactRequest = ({ flashError, flashSuccess = false }: Props) => {
  const {
    company: { subscription, numberEmployees },
  } = useCurrentSession()
  const contactSales = shouldContactSales(subscription.inFreeTrial, numberEmployees)
  const { pathname } = useLocation()

  const eventEmitter = (from: string) => {
    const currentSubscription = subscriptions.current

    track(trackingEvents.onboarding.requestToContact, {
      page_path: pathname,
      page_url: window.location.href,
      request_type: contactSales ? 'Contact CX' : 'Book a meeting',
      from: from,
      company_plan: subscription.inFreeTrial
        ? ['free']
        : currentSubscription.chargebeeSubscriptionItems.map((e) => e.item_price_id),
    })
  }

  const { email } = useCurrentSession()

  const { performAction: action, running: loading } = useAsyncAction(
    () => {
      return qualificationEntries.create({
        contact_email: email,
        target: QualificationEntry.TargetTeams.sales,
        marketing_form_campaign: contactSales
          ? QualificationEntry.Campaigns.contactSalesApp
          : QualificationEntry.Campaigns.contactCx,
      })
    },
    {
      errorFlash: flashError,
      successFlash: flashSuccess,
      successMessage: i18n.t('onboarding.new_contact_request.success_message'),
      errorMessage: i18n.t('onboarding.new_contact_request.error_message'),
    }
  )

  return { action, loading, eventEmitter, teamContacted: contactSales ? 'Sales' : 'CX' }
}

export default useNewContactRequest
